if (Number.parseInt === undefined) {
    Number.parseInt = window.parseInt
}